import {Observable, tap} from 'rxjs';
import {notificationsManager} from '@innowise-group/ui-kit';
import {DoorsApi} from './doors-api.types';
import {GlobalContainerTypes, Http, inject, injectable} from '../..';

@injectable()
class DoorsApiService implements DoorsApi {
  public static readonly type = GlobalContainerTypes.DoorsApi;

  @inject(GlobalContainerTypes.Http) private http: Http;

  public deleteDoor(id: string): Observable<void> {
    return this.http.DELETE<void>(`/doors/${id}/`).pipe(
      tap(() => {
        notificationsManager.success({title: 'success', subtitle: 'deleteDoor'});
      }),
    );
  }
}

export default DoorsApiService;
